<script setup lang="ts">
import ImageSourceSet from '../shared/image/SourceSet.vue'

import type { ImageParagraph } from '../../utils/paragraph-schema/paragraphs'
import type { Brand } from '@xcel-next/core/enums'

type ImageProps = NonNullable<ImageParagraph['image']>

withDefaults(defineProps<{
  image: ImageProps,
  brand?: Brand,
  typeCount?: number,
  listOrderPosition?: number,
  isPreview?: boolean,
  imageSrcSetName?: string
}>(), {
  typeCount: 0,
  listOrderPosition: -1,
  isPreview: false
})

const getStyleClassForLayoutSize = (layout: ImageProps['layout']): string => {
  switch (layout?.size) {
    case 'm': return 'bx-content--floating'
    default: return ''
  }
}

const toImageSizeStyleClass = (layout: ImageProps['layout']): string =>
  layout?.size?.length ? 'bx-content--image-' + layout.size : ''
</script>

<template>
  <div :class="['bx-content__media', 'bx-typo--content-media', toImageSizeStyleClass(image.layout)]"
       :data-tc="`image-${image.layout?.size}`">
    <div :class="['bx-content', getStyleClassForLayoutSize(image.layout)]">
      <ImageSourceSet :image="image"
                      :brand="brand"
                      :list-order-position="listOrderPosition"
                      :image-src-set-name="imageSrcSetName"
                      :type-count="typeCount"
                      :is-preview="isPreview" />
    </div>
  </div>
</template>
